import { useTranslation } from 'react-i18next'
import { shallowEqual } from 'react-redux'

import { useCharlieUser } from 'hooks/useCharlieUser'
import { AreaType } from 'store/area/types'
import { useGetAuditAreasQuery } from 'store/audit/auditApiWithQuery'
import { useAppSelector } from 'store/hooks'
import { State } from 'store/state'
import { QueryStatus } from 'store/types'

import { insightsEqualityViewedEvent } from 'utils/analytics/amplitudeEvents'

import { IReportsSidebarMenuGroup } from '../types/reportSidebarMenuGroup'

export const useMenuGroupEquality = (): {
  sidebarItems: IReportsSidebarMenuGroup | undefined
  status: QueryStatus
} => {
  const { sessionId } = useAppSelector(
    (state: State) => ({
      sessionId: state.apiHeadersReducer.sessionId,
    }),
    shallowEqual
  )

  const charlieUser = useCharlieUser()
  const { t } = useTranslation()

  const {
    data: subAreas,
    isSuccess: isAreasSucess,
    isLoading: isAreaLoading,
    isError: isAreaError,
  } = useGetAuditAreasQuery({
    sessionId,
    query: { type: AreaType.SUB },
  })

  if (isAreaLoading || isAreaError) {
    return {
      sidebarItems: undefined,
      status: isAreaLoading ? QueryStatus.LOADING : QueryStatus.ERROR,
    }
  }

  if (isAreasSucess && subAreas && subAreas.length > 0) {
    const EQUALITY_CODE = 'equality'

    const equalitySubAreas = subAreas.filter(
      ({ parentAreaCode }: any) => parentAreaCode === EQUALITY_CODE
    )
    const sidebarItems: IReportsSidebarMenuGroup = {
      code: EQUALITY_CODE,
      text: t(`${EQUALITY_CODE}.title`),
      enabled: true,
      url: `/${EQUALITY_CODE}`,
      items: equalitySubAreas.map(({ code, title }: any) => ({
        code,
        text: title,
        url: `/${EQUALITY_CODE}/${encodeURIComponent(code)}`,
        enabled: !!title,
        onClick: () =>
          insightsEqualityViewedEvent({ topic: code }, charlieUser),
      })),
    }

    return {
      sidebarItems,
      status: QueryStatus.SUCCESS,
    }
  }

  return { sidebarItems: undefined, status: QueryStatus.SUCCESS }
}
